<template>
  <el-dialog
    title="Comissão do Corretor"
    :visible.sync="visibility"
    :close-on-click-modal="false"
    :before-close="fechar"
    append-to-body
    @open="reset"
    width="40%"
    v-loading="loading"
  >
    <el-form :model="comissaoCorretor" ref="formComissao" size="small" label-position="top">
      <el-form-item label="Corretor" style="width: 100%">
        <el-select 
          v-model="comissaoCorretor.usuarioSelecionado"
          @change="definirComissao"
          :remote-method="filtrarUsuariosSelect"
          :loading="loadingUsuarios"
          @focus="filtrarUsuariosSelect"
          value-key="id"
          placeholder
          v-if="!comissaoImobiliaria"
          loading-text="Carregando usuários"
          no-data-text="Nenhum usuário encontrado"
          filterable
          remote
          reserve-keyword
          style="width: 100%"
        >
          <el-option
            v-for="item in usuariosDisponiveis"
            :key="item.id"
            :label="item.nome + ` - ${ getLabelPerfilUsuario(item.perfil)}`"
            :value="item"
          ></el-option>
        </el-select>

        <el-input value="IMOBILIÁRIA" v-if="comissaoImobiliaria" readonly></el-input>
      </el-form-item>

      <el-row :gutter="20">
        <el-col>
          <el-form-item label="Comissão">
            <el-switch
              v-model="percentualComissaoIsSelecionado"
              inactive-text="Valor"
              active-text="Percentual"
              active-color="#008080"
              inactive-color="#008080"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="percentualComissaoIsSelecionado" :gutter="20">
        <el-col :span="10">
          <el-form-item prop="comissao">
            <el-input
              v-model="comissaoCorretor.comissao"
              @input="calcularValorComissao"
              @keypress.native="validarInputNumerico"
              @keyup.native="validarSeparadorDecimal"
            >
              <template slot="append">
                {{ percentualComissaoIsSelecionado ? "%" : "" }}
              </template>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-tag style="font-size: 14px">
            {{ this.formatarValor(comissaoCorretor.valorComissao) }}
          </el-tag>
        </el-col>
      </el-row>

      <el-row v-else :gutter="20">
        <el-col :span="10">
          <el-form-item prop="comissao">
            <el-input
              v-model="comissaoCorretor.valorComissao"
              @input="calcularComissao"
              @keypress.native="validarInputNumerico"
              @keyup.native="validarSeparadorDecimal"
            >
              <template slot="prepend">
                {{ !percentualComissaoIsSelecionado ? "R$" : "" }}
              </template>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-tag style="font-size: 14px">
            {{ this.formatarPercentual(comissaoCorretor.comissao) }}
          </el-tag>
        </el-col>
      </el-row>

      <!-- <el-col :span="6">
        <el-form-item label="Comissão(%)" prop="comissao">
          <div class="el-input el-input--small">
            <money
              v-model="comissaoCorretor.comissao"
              v-bind="percent"
              class="el-input__inner"
              readonly
            />
          </div>
        </el-form-item>
      </el-col>

      <el-col :span="7">
        <el-form-item label="Comissão(R$)">
          <div class="el-input el-input--small">
            <money 
              v-model="comissaoCorretor.valorComissao" 
              v-bind="money" 
              class="el-input__inner" 
              @input="calcularComissao"/>
          </div>
        </el-form-item>
      </el-col> -->
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="adicionarComissaoVendaHandler" type="primary" round class="btn-box-shadow">Confirmar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";

import Util from "../../../util/funcoes.js";
import { PERFIS_USUARIO } from "../../../util/constantes.js"

export default {
  props: {
    visibility: Boolean,
    comissaoImobiliaria: Boolean
  },
  data() {
    return {
      loadingUsuarios: false,
      percentualComissaoIsSelecionado: true,

      comissaoCorretor: {
        usuarioSelecionado: { id: 0, nome: "" },
        comissao: 0,
        valorComissao: 0,
      },
      
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },

      percent: {
        decimal: ",",
        thousands: ".",
        suffix: " %",
        precision: 2,
        masked: false
      }
    };
  },
  computed: {
    ...mapState("vendasContratosStore", {
      venda(state) {
        return state.vendaSelecionada;
      },
      usuariosDisponiveis() {
        return this.$store.state.vendasContratosStore.usuariosDisponiveis;
      }
    }),
    loading() {
      return this.$store.state.loading;
    },
    perfisUsuarios() {
      return PERFIS_USUARIO;
    }
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("vendasContratosStore", ["listarUsuarios"]),

    filtrarUsuariosSelect(queryString) {
      if(queryString.type && queryString.type === 'focus') { queryString = '' }
      let payload = { nome: queryString, perfil: 'TODOS' };
      this.loadingUsuarios = true;
      this.listarUsuarios(payload).then(() => {
        this.loadingUsuarios = false;
      });
    },

    definirComissao(){
      this.usuariosDisponiveis.map(item =>{ 
      item.id === this.comissaoCorretor.usuarioSelecionado.id ? this.comissaoCorretor.comissao = item.comissao: false})
      this.calcularValorComissao()
    },

    adicionarComissaoVendaHandler() {
      this.$refs["formComissao"].validate(valid => {
        if(valid) {
          this.adicionarComissaoVenda();
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        }
      });
    },
    adicionarComissaoVenda() {
      let comissaoVenda = {
        id: 0,
        corretor: {
          id: this.comissaoCorretor.usuarioSelecionado.id,
          nome: this.comissaoCorretor.usuarioSelecionado.nome
        },
        percentual: this.comissaoCorretor.comissao,
        valor: this.comissaoCorretor.valorComissao
      };
      this.venda.comissoes.push(comissaoVenda);
      this.fechar();
    },
    reset() {
      this.comissaoCorretor = {
        usuarioSelecionado: { id: 0 },
        comissao: "",
        valorComissao: ""
      }
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    },
    formatarValor(valor) {
      return Util.formatarValor(valor);
    },
    formatarPercentual(percentual) {
      return Util.formatarPercentual(percentual);
    },
    fechar() {
      this.$refs["formComissao"].resetFields();
      this.$emit("close");
    },
    calcularValorComissao() {
      let totalComissao = this.venda.valorComissao - this.venda.valorImpostoComissao;
      const novaComissao = (
        (totalComissao * (this.comissaoCorretor.comissao * 100)) /
        10000
      ).toFixed(2);

      if(isFinite(novaComissao)) {
        this.comissaoCorretor.valorComissao = novaComissao;
      } else {
        this.comissaoCorretor.valorComissao = 0;
      }
    },
    calcularComissao() {
      let totalComissao = this.venda.valorComissao - this.venda.valorImpostoComissao;
      const novaComissao = ((this.comissaoCorretor.valorComissao / totalComissao) * 100).toFixed(2);

      if(isFinite(novaComissao)) {
        this.comissaoCorretor.comissao = novaComissao;
      } else {
        this.comissaoCorretor.comissao = 0;
      }
    },

    validarSeparadorDecimal(event) {
      const textoDigitado = event.target.value;
      
      const textoComVirgulasTratadas = this.substituirTodaVirgulaPorPonto(textoDigitado);
      const textoComPontosTratados = this.removerTodosOsPontosDepoisDoPrimeiro(textoComVirgulasTratadas);

      const textoFinal = textoComPontosTratados;

      event.target.value = textoFinal;
    },

    validarInputNumerico(event) {
      const valorDigitado = event.key;
      const valoresPermitidos = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ','];
      const valorNaoEhPermitido = !valoresPermitidos.includes(valorDigitado);

      if(valorNaoEhPermitido) event.preventDefault();
    },

    substituirTodaVirgulaPorPonto(texto) {
      return texto.replace(/,/g, '.');
    },
    removerTodosOsPontosDepoisDoPrimeiro(texto) {
      return texto.replace(/(?<=\..*)\./g, '');
    },

    getLabelPerfilUsuario(perfil) {
      return Util.getLabel(PERFIS_USUARIO, perfil);
    },

  }
};
</script>

